//const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';
import { isLocal } from './config';

export const getApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;

  // Use Azure API if not running locally
  //const isLocal = window.location.hostname.includes('localhost');
  const baseUrl = isLocal
    ? ''
    : (import.meta.env.VITE_API_BASE_URL || 'https://app-dictionary.azurewebsites.net');


  return `${baseUrl}/api/${cleanEndpoint}`;
};

